
<ng-container [ngSwitch]="profilesMode">
  <app-profiles-grid *ngSwitchCase="profilesModeModal.GRID_VIEW"></app-profiles-grid>
  <app-dynamic-form-loader *ngSwitchCase="profilesModeModal.PROFILE_FORM_VIEW" [formComponent]="component"></app-dynamic-form-loader>
  <app-singular-profile-content *ngSwitchCase="profilesModeModal.SINGULAR_PROFILE_VIEW"></app-singular-profile-content>
  <app-rules-association *ngSwitchCase="profilesModeModal.SINGULAR_RULES_ASSOCIATION_PROFILE_VIEW"></app-rules-association >
</ng-container>
